import React, { useContext } from 'react';
import {
  VistaGoogleOneTap,
  TRACKING_EVENT_NAME,
  TRACKING_CATEGORY,
  TRACKING_LABEL,
  TRACKING_ACTIONS,
  GoogleOneTapNotification,
} from '@vp/google-one-tap';
import { TrackingContext } from '../../hooks/useTracking';

export interface GoogleOneTapProps {
  auth: any;
}

export const GoogleOneTap = (props: GoogleOneTapProps) => {
  const { trackGoogleOneTap } = useContext(TrackingContext);

  const { auth } = props;
  const identity = auth?.getIdentity();
  const isIdentityInitialized = identity?.authorizationHeader !== undefined;
  const isSignedIn = identity?.isSignedIn;

  return (
    <VistaGoogleOneTap
      authData={{
        auth: auth,
        isIdentityInitialized: isIdentityInitialized,
        isSignedIn: isSignedIn,
      }}
      onCredentialResponse={() => {
        handleCredentialResponse(trackGoogleOneTap);
      }}
      onNotificationEvent={(
        eventType: GoogleOneTapNotification,
        reason: string
      ) => {
        handleNotificationEvent(trackGoogleOneTap, eventType, reason);
      }}
    />
  );
};

const handleCredentialResponse = (trackGoogleOneTap: any) => {
  trackGoogleOneTap(
    TRACKING_EVENT_NAME,
    TRACKING_CATEGORY,
    TRACKING_LABEL,
    TRACKING_ACTIONS.SIGNED_IN,
    ''
  );
};

const handleNotificationEvent = (
  trackGoogleOneTap: (
    eventName: string,
    category: string,
    label: string,
    action: string,
    reason: string
  ) => void,
  eventType: GoogleOneTapNotification,
  reason: string
) => {
  trackGoogleOneTap(
    TRACKING_EVENT_NAME,
    TRACKING_CATEGORY,
    TRACKING_LABEL,
    getGoogleOneTapTrackingAction(eventType),
    reason
  );
};

const getGoogleOneTapTrackingAction = (
  eventType: GoogleOneTapNotification
): string => {
  switch (eventType) {
    case GoogleOneTapNotification.IS_NOT_DISPLAYED:
      return TRACKING_ACTIONS.NOT_DISPLAYED;
    case GoogleOneTapNotification.IS_SKIPPED_MOMENT:
      return TRACKING_ACTIONS.SKIPPED;
    case GoogleOneTapNotification.IS_DISMISSED_MOMENT:
      return TRACKING_ACTIONS.DISMISSED;
  }
};
